import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useForm } from "react-hook-form";
import { Tooltip } from "primereact/tooltip";
import { Link, useLocation } from "react-router-dom";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Skeleton } from "primereact/skeleton";
import { Messages } from "primereact/messages";
// components
import NumberInput from "../../components/input/NumberInput";
//services
import { getCommissionsById } from "../../services/Commissions/getCommissionsById";
//utils
import { formatCurrency } from "../../utils/formatCurrency";
import { formatDate } from "../../utils/formatDate";
//calculos
import { calcCommissionGeral } from "./CommissionsCalculations/CommissionsCalculations";

export function LaunchCommissionView() {
  const form = useForm();
  const msgs = useRef(null);
  const errors = form.formState.errors;
  //recebendo o objeto da tela anterior
  const location = useLocation();
  const commissionId =
    typeof location.state === "object"
      ? location.state.commissionId
      : location.state; // Extrai o número puro
  //states
  const [objectCommission, setObjectCommission] = useState({});
  const [loading, setLoading] = useState(null);
  const [selectedBrokers, setSelectedBrokers] = useState([]);
  const [calendarValue, setCalendarValue] = useState(new Date()); // Data inicial para Calendar
  const [calendarValues, setCalendarValues] = useState({});
  const [totalBroker, setTotalBroker] = useState(0);
  const [totalImob, setTotalImob] = useState(0);
  const [totalBrokerImob, setTotalBrokerImob] = useState(0);
  const [showPercentage, setShowPercentage] = useState(true);
  const [showMessage, setShowMessage] = useState(true); // Controla a exibição da mensagem

  const getCommission = async (id) => {
    try {
      setLoading(true);
      const response = await getCommissionsById(id); // Chamada para obter a comissão
      setObjectCommission(response);
      // console.log("response commission by id ", response);
    } catch (error) {
      console.error("Erro ao buscar comissão:", error);
    }
    setLoading(false);
  };
  //header
  const items = [
    {
      template: () => (
        <Link to={"/financial/launchCommission"} className="p-breadcrumb-link">
          Comissões
        </Link>
      ),
    },
    {
      template: () => (
        <Link to={"/financial/launchCommission"} className="p-breadcrumb-link">
          Visualizar Comissões
        </Link>
      ),
    },
  ];
  //header
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const handlePDFCommissions = async () => {
    const input = document.getElementById("invoice-pdf");
    if (!input) {
      console.error("Elemento para captura não encontrado!");
      return;
    }

    try {
      const canvas = await html2canvas(input, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      pdf.save(
        `Comissao_${
          objectCommission?.commission?.enterprise || "Desconhecido"
        }.pdf`
      );
    } catch (error) {
      console.error("Erro ao gerar o PDF:", error);
    }
  };

  const setValueImob = () => {
    if (!objectCommission?.commission) return;
    const realEstateId = objectCommission.commission.real_estate_id;
    const realEstateUser = objectCommission.commission.commissionUsers.find(
      (user) => user.user_id === realEstateId
    );
    if (realEstateUser) {
      const totalInstallments = realEstateUser.installments.length;
      const installmentValue = realEstateUser.installments[0]?.value || 0;
      const firstInstallmentDate =
        realEstateUser.installments[0]?.due_date || null;
      // console.log("firstInstallmentDate", firstInstallmentDate);
      // Definir valores no formulário
      form.setValue("value_installment_imob", installmentValue);
      form.setValue("quantity_installment_imob", totalInstallments);
      // Definir a data da primeira parcela no estado
      if (firstInstallmentDate) {
        const [year, month, day] = firstInstallmentDate.split("-").map(Number);
        setCalendarValue(new Date(year, month - 1, day)); // Mês começa do 0 em JS
      }
    }
  };
  const setValueBrokers = () => {
    if (!objectCommission?.commission?.commissionUsers) return;
    const realEstateId = objectCommission.commission.real_estate_id;

    // Filtrar corretores que possuem installments e não são a imobiliária
    const brokers = objectCommission.commission.commissionUsers
      .filter(
        (user) => user.user_id !== realEstateId && user.installments.length > 0
      )
      .map((user) => {
        const firstInstallment = user.installments[0];
        let dueDate = null;

        if (firstInstallment?.due_date) {
          // Garantir que a data seja interpretada corretamente sem problemas de fuso horário
          const [year, month, day] = firstInstallment.due_date
            .split("-")
            .map(Number);
          dueDate = new Date(year, month - 1, day); // Ajustando mês (JavaScript começa do 0)
        }

        return {
          id: user.user_id,
          name: user.name,
          percentage: user.percentage,
          value: firstInstallment?.value || 0,
          quantity: user.installments.length,
          due_date: dueDate,
        };
      });

    setSelectedBrokers(brokers);

    brokers.forEach((broker, index) => {
      form.setValue(`porc_installment_broker_${index}`, broker.percentage);
      form.setValue(`value_installment_broker_${index}`, broker.value);
      form.setValue(`quantity_installment_broker_${index}`, broker.quantity);
    });

    setCalendarValues(brokers.map((b) => b.due_date));
  };

  const calculateTotals = () => {
    if (!objectCommission?.commission?.commissionUsers) return;

    const realEstateId = objectCommission.commission.real_estate_id;

    let totalImobValue = 0;
    let totalBrokersValue = 0;

    objectCommission.commission.commissionUsers.forEach((user) => {
      if (user.user_id === realEstateId) {
        // Cálculo do total da imobiliária
        totalImobValue = user.installments.reduce(
          (acc, installment) => acc + installment.value,
          0
        );
      } else if (user.installments.length > 0) {
        // Cálculo do total dos corretores
        totalBrokersValue += user.installments.reduce(
          (acc, installment) => acc + installment.value,
          0
        );
      }
    });

    setTotalImob(totalImobValue);
    setTotalBroker(totalBrokersValue);
    setTotalBrokerImob(totalImobValue + totalBrokersValue);
  };
  const calculateRealEstatePercentage = () => {
    if (!objectCommission?.commission?.commissionUsers) return;

    const realEstateId = objectCommission.commission.real_estate_id;

    // Somar as porcentagens de todos os corretores (excluindo a imobiliária)
    const totalBrokersPercentage = objectCommission.commission.commissionUsers
      .filter((user) => user.user_id !== realEstateId) // Exclui a imobiliária
      .reduce((acc, user) => acc + user.percentage, 0);

    // Calcular a porcentagem da imobiliária (100% - soma das porcentagens dos corretores)
    const realEstatePercentage = Math.max(0, 100 - totalBrokersPercentage);

    // Atualizar estado e formulário
    form.setValue("porc_installment_imob", realEstatePercentage);
  };
  const toggleShowPercentage = () => {
    setShowPercentage(!showPercentage);
  };
  const showCustomMessage = () => {
    if (
      objectCommission.commission?.is_default === 0 &&
      msgs.current &&
      showMessage
    ) {
      msgs.current.show([
        {
          severity: "info",
          summary: "Info",
          detail: (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>Essa venda saiu do padrão de comissão.</span>
              <i
                className="pi pi-times text-black ml-3"
                style={{ cursor: "pointer", marginLeft: "10px" }}
                onClick={() => setShowMessage(false)} // Fecha a mensagem ao clicar
              ></i>
            </span>
          ),
          sticky: true,
          closable: false, // Removemos o botão padrão de fechar
        },
      ]);
    }
  };

  useEffect(() => {
    if (commissionId) {
      getCommission(commissionId);
    }
  }, [commissionId]);

  useEffect(() => {
    setValueImob();
    setValueBrokers();
    calculateTotals();
    calculateRealEstatePercentage();
    showCustomMessage();
  }, [objectCommission]);

  return (
    <div className="row d-flex justify-content-center">
      {loading ? (
        <div className="row">
          <div className="col-md-4 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-4 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-4 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-6 my-3">
            <Skeleton width="100%" height={45} />
          </div>
          <div className="col-md-12">
            <Skeleton width="100%" height={150} />
          </div>
          <div className="row justify-content-end">
            <div className="col-md-3 pt-3">
              <Skeleton width="100%" height={45} />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="col-md-4">
            <BreadCrumb
              model={items}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
          </div>
          <div className="col-md-8 text-end">
            <Button
              label="Imprimir"
              onClick={handlePDFCommissions}
              icon={"fa-solid fa-check"}
              iconPos="right"
            />
          </div>
          <div id="invoice-pdf" className="invoice">
            <div className="invoice-company">
              {objectCommission?.commission?.enterprise || "Carregando..."} |{" "}
              Quadra {objectCommission?.commission?.land || "Carregando..."}{" "}
              Lote {objectCommission?.commission?.block || "Carregando..."}
            </div>
            <div className="invoice-header">
              <div className="invoice-from">
                <small>Cliente</small>
                <address className="mt-5px mb-5px">
                  <strong className="text-dark">
                    {objectCommission?.commission?.client || "Carregando..."}
                  </strong>
                  <br />
                  CPF:
                  {objectCommission?.commission?.client_doc || "Carregando..."}
                  <br />
                </address>
              </div>
              <div className="invoice-to">
                <small>Corretor Selecionado</small>
                <address className="mt-5px mb-5px">
                  <strong className="text-dark">
                    {objectCommission?.commission?.broker || "Carregando..."}
                  </strong>
                  <br />
                  Email:{" "}
                  {objectCommission?.commission?.broker_email ||
                    "Carregando..."}
                  <br />
                </address>
              </div>
              <div className="invoice-to">
                <small>Imobiliária Selecionada</small>
                <address className="mt-5px mb-5px">
                  <strong className="text-dark">
                    {objectCommission?.commission?.real_estate ||
                      "Carregando..."}
                  </strong>
                </address>
              </div>
              <div className="invoice-date">
                <small>Data da Venda</small>
                <div className="date text-dark mt-5px">
                  {objectCommission?.commission?.created_at
                    ? formatDate(objectCommission?.commission?.created_at)
                    : "Carregando..."}
                </div>
                <div>
                  Valor do Lote:{" "}
                  {objectCommission?.commission?.value_land
                    ? formatCurrency(objectCommission?.commission?.value_land)
                    : "Carregando..."}
                </div>
              </div>
            </div>
            {showMessage && <Messages ref={msgs} />}

            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="invoice-company">
                  Porcentagem Geral de Comissão{" "}
                  {objectCommission?.commission?.percentage || "Carregando..."}%
                  -{" "}
                  {formatCurrency(
                    calcCommissionGeral(
                      objectCommission?.commission?.percentage,
                      objectCommission?.commission?.value_land
                    )
                  )}{" "}
                </div>
              </div>
            </div>
            <div className="invoice-company">IMOBILIÁRIA </div>
            <div className="invoice-content">
              <div className="table-responsive">
                <Button
                  icon={showPercentage ? "pi pi-eye" : " pi pi-eye-slash"}
                  className="p-button-text"
                  onClick={toggleShowPercentage}
                  tooltip={
                    showPercentage
                      ? "Ocultar porcentagem"
                      : "Mostrar porcentagem"
                  }
                />

                <table className="table table-invoice">
                  <thead>
                    <tr>
                      <th className="text-start">IMOBILIÁRIA</th>
                      <th className="text-start">
                        PORCENTAGEM DE COMISSÃO{" "}
                        <Tooltip
                          target=".custom-target"
                          position="top"
                          className=""
                        />
                        <i
                          className=" custom-target pi pi-question-circle p-text-secondary"
                          data-pr-tooltip="A imobiliária começa com 100% da comissão, mas essa porcentagem pode ser reduzida conforme as comissões dos corretores são distribuídas."
                          style={{ cursor: "pointer" }}
                        ></i>
                      </th>

                      <th className="text-start">VALOR DA PARCELA</th>
                      <th className="text-start">QUANTIDADE PARCELAS</th>
                      <th className="text-end" width="20%">
                        VENCIMENTO 1ª PARCELA
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="align-middle">
                        <span className="text-dark">
                          {objectCommission?.commission?.real_estate ||
                            "Carregando..."}
                        </span>
                      </td>
                      <td className="align-middle">
                        {showPercentage && (
                          <NumberInput
                            name="porc_installment_imob"
                            control={form.control}
                            errors={errors}
                            suffix="%"
                            placeholder="0%"
                            disabled
                            value={form.watch("porc_installment_imob")}
                          />
                        )}
                      </td>

                      <td className="align-middle">
                        <NumberInput
                          name="value_installment_imob"
                          control={form.control}
                          errors={errors}
                          min={0}
                          useGrouping={true}
                          locale="pt-BR"
                          placeholder="R$ 0,00"
                          prefix="R$"
                          defaultValue={form.getValues(
                            "value_installment_imob"
                          )}
                          disabled
                        />
                      </td>
                      <td className="align-middle">
                        <NumberInput
                          name="quantity_installment_imob"
                          control={form.control}
                          errors={errors}
                          mode="decimal"
                          min={1}
                          max={100}
                          useGrouping={false}
                          defaultValue={form.getValues(
                            "quantity_installment_imob"
                          )}
                          disabled
                        />
                      </td>
                      <td className="align-middle">
                        <Calendar
                          style={{ marginTop: "20px" }}
                          value={calendarValue}
                          dateFormat="dd/mm/yy"
                          disabled
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="invoice-company">CORRETOR </div>
              </div>
            </div>
            <div className="invoice-content">
              <div className="table-responsive">
                <table className="table table-invoice">
                  <thead>
                    <tr>
                      <th className="text-start">CORRETOR</th>
                      <th className="text-start">
                        COMISSÃO DO CORRETOR{" "}
                        <Tooltip
                          target=".custom-target"
                          position="top"
                          className=""
                        />
                        <i
                          className=" custom-target pi pi-question-circle p-text-secondary"
                          data-pr-tooltip="Essa é a porcentagem dos corretores definidas em Times"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </th>
                      <th className="text-start">VALOR DA PARCELA</th>
                      <th className="text-start">QUANTIDADE PARCELAS</th>
                      <th className="text-end" width="20%">
                        VENCIMENTO 1ª PARCELA
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedBrokers.map((broker, index) => (
                      <tr key={broker.id}>
                        <td className="align-middle">
                          <span className="text-dark">{broker.name}</span>
                        </td>
                        <td className="align-middle">
                          {showPercentage && (
                            <NumberInput
                              name={`porc_installment_broker_${index}`}
                              control={form.control}
                              errors={errors}
                              suffix="%"
                              value={form.watch(
                                `porc_installment_broker_${index}`
                              )}
                              disabled
                            />
                          )}
                        </td>
                        <td className="align-middle">
                          <NumberInput
                            name={`value_installment_broker_${index}`}
                            control={form.control}
                            errors={errors}
                            mode="currency"
                            currency="BRL"
                            min={0}
                            useGrouping={true}
                            locale="pt-BR"
                            placeholder="R$ 0,00"
                            value={form.watch(
                              `value_installment_broker_${index}`
                            )}
                            disabled
                          />
                        </td>
                        <td className="align-middle">
                          <NumberInput
                            name={`quantity_installment_broker_${index}`}
                            control={form.control}
                            errors={errors}
                            mode="decimal"
                            min={1}
                            max={100}
                            useGrouping={false}
                            value={form.watch(
                              `quantity_installment_broker_${index}`
                            )}
                            disabled
                          />
                        </td>
                        <td className="align-middle">
                          <Calendar
                            style={{ marginTop: "20px" }}
                            value={calendarValues[index] || null}
                            dateFormat="dd/mm/yy"
                            disabled
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="invoice-price">
              <div className="invoice-price-left">
                <div className="invoice-price-row">
                  <div className="sub-price">
                    <small>COMISSÃO CORRETAGEM</small>
                    <span className="text-dark" name="total_broker">
                      <p name="total_broker">{formatCurrency(totalBroker)}</p>{" "}
                    </span>
                  </div>
                  <div className="sub-price">
                    <i className="fa fa-plus text-muted"></i>
                  </div>

                  <div className="sub-price">
                    <small>COMISSÃO IMOBILIÁRIA</small>
                    <span className="text-dark" name="total_imob">
                      <p name="total_broker">{formatCurrency(totalImob)}</p>{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="invoice-price-right">
                <small>Total</small>{" "}
                <span className="fw-bold">
                  <p name="total_broker">{formatCurrency(totalBrokerImob)}</p>{" "}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
